// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import ProofDetailsActionTypes from './proof-details.types';
import {
	proofDetailsAdd,
	fetchProofDetails,
	updateProofDetails,
	deleteProofDetails,
} from './proof-details.service';

import {
	addBusinessProofSuccess,
	addBusinessProofFailure,
	addBusinessProofResponseChanged,
	updateBusinessProofSuccess,
	updateBusinessProofFailure,
	updateBusinessProofResponseChanged,
	fetchBusinessProofSuccess,
	fetchBusinessProofFailure,
	fetchBusinessProofResponseChanged,
	deleteBusinessProofSuccess,
	deleteBusinessProofFailure,
	deleteBusinessProofResponseChanged,
} from './proof-details.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD BUSINESS PROOF  ******************** */
export function* businessProofAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, proofListArr } = payload;
		const key = 'BusinessProofKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessProofList: proofListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(proofDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessProofFailure(responseData.data));
		} else {
			yield put(addBusinessProofSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessProofFailure(error));
	}
}

export function* resetAddBusinessProofResponse() {
	yield put(addBusinessProofResponseChanged());
}

export function* onAddBusinessProofDetails() {
	yield takeLatest(ProofDetailsActionTypes.ADD_BUSINESS_PROOF_START, businessProofAdd);
}

export function* onAddBusinessProofResponseReset() {
	yield takeLatest(
		ProofDetailsActionTypes.ADD_BUSINESS_PROOF_RESPONSE_RESET,
		resetAddBusinessProofResponse,
	);
}
/** *********************  END ADD BUSINESS PROOF ******************** */

/** *********************  START UPDATE BUSINESS PROOF  ******************** */
export function* businessProofUpdate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, proofListArr } = payload;
		const key = 'UpdateBusinessProofKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessProofList: proofListArr,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateProofDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessProofFailure(responseData.data));
		} else {
			yield put(updateBusinessProofSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessProofFailure(error));
	}
}

export function* resetUpdateBusinessProofResponse() {
	yield put(updateBusinessProofResponseChanged());
}

export function* onUpdateBusinessProofDetails() {
	yield takeLatest(ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_START, businessProofUpdate);
}

export function* onUpdateBusinessProofResponseReset() {
	yield takeLatest(
		ProofDetailsActionTypes.UPDATE_BUSINESS_PROOF_RESPONSE_RESET,
		resetUpdateBusinessProofResponse,
	);
}
/** *********************  END ADD BUSINESS PROOF ******************** */

/** *********************  START FETCH BUSINESS PROOF  ******************** */
export function* businessProofFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBusinessProofKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchProofDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessProofFailure(responseData.data));
		} else {
			yield put(fetchBusinessProofSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessProofFailure(error));
	}
}

export function* resetFetchBusinessProofResponse() {
	yield put(fetchBusinessProofResponseChanged());
}

export function* onFetchBusinessProofDetails() {
	yield takeLatest(ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_START, businessProofFetch);
}

export function* onFetchBusinessProofResponseReset() {
	yield takeLatest(
		ProofDetailsActionTypes.FETCH_BUSINESS_PROOF_RESPONSE_RESET,
		resetFetchBusinessProofResponse,
	);
}
/** *********************  END FETCH BUSINESS PROOF ******************** */

/** *********************  START DELETE BUSINESS PROOF ******************** */
export function* businessProofDelete({ payload }: any) {
	try {
		const { businessProofID, companyID, databaseName } = payload;
		const key = 'DeleteBusinessProofDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BusinessProofID: businessProofID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deleteProofDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessProofFailure(responseData.data));
		} else {
			yield put(deleteBusinessProofSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessProofFailure(error));
	}
}

export function* resetDeleteBusinessProofResponse() {
	yield put(deleteBusinessProofResponseChanged());
}

export function* onDeleteBusinessProofDetails() {
	yield takeLatest(ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_START, businessProofDelete);
}

export function* onDeleteBusinessProofResponseReset() {
	yield takeLatest(
		ProofDetailsActionTypes.DELETE_BUSINESS_PROOF_RESPONSE_RESET,
		resetDeleteBusinessProofResponse,
	);
}
/** *********************  END DELETE BUSINESS PROOF ******************** */

export function* proofDetailsSaga() {
	yield all([
		call(onAddBusinessProofDetails),
		call(onAddBusinessProofResponseReset),
		call(onUpdateBusinessProofDetails),
		call(onUpdateBusinessProofResponseReset),
		call(onFetchBusinessProofDetails),
		call(onFetchBusinessProofResponseReset),
		call(onDeleteBusinessProofDetails),
		call(onDeleteBusinessProofResponseReset),
	]);
}
